export default {
  'message.successSave': '{{entity}} wurde erfolgreich erstellt',
  'message.successUpdate': '{{entity}} wurde erfolgreich aktualisiert',
  'message.errorSave':
    'Beim Erstellen von {{entity}} ist ein Fehler aufgetreten',
  'message.errorUpdate':
    'Beim Aktualisieren von {{entity}} ist ein Fehler aufgetreten',
  'message.errorGet': '{{entity}} konnte nicht abgerufen werden',
  'message.errorDownload': 'Fehler beim Herunterladen der Datei',
  'message.successDelete': '{{entity}} wurde erfolgreich gelöscht',
  'message.errorDelete': '{{entity}} konnte nicht gelöscht werden',
  'message.successSentVerificationEmail':
    'Bestätigungs-E-Mail erfolgreich gesendet',
  'message.pendingEmailVerification': 'E-Mail-Bestätigung ausstehend',
  'message.errorSentVerificationEmail':
    'Fehler beim Senden der Bestätigungs-E-Mail',
  'message.delete.explain': '{{entity}} wurde als gelöscht markiert',
  'message.delete.info': 'Löschen ist nur im Bearbeitungsmodus verfügbar',
  'message.deactivate.info': '{{entity}} deaktivieren',
  'message.delete.warning':
    'Sind Sie absolut sicher, dass Sie dieses {{entity}} löschen möchten?',
  'message.deactivate.warning':
    'Sind Sie sicher, dass Sie dieses {{entity}} löschen möchten? Es wird zuerst als deaktiviert markiert, bevor es gelöscht wird.',
  'message.delete.confirm':
    'Wenn Sie das Löschen bestätigen, wird die Aktion ausgeführt. Es kann sein, dass {{entity}} aus einer Datenbank entfernt wird.',
  'message.inactive.confirm':
    'Die Entität wird als inaktiv markiert. Sie wird nicht mehr sichtbar oder verwendbar sein, aber nicht aus dem System gelöscht.',
  'message.unassigned.warning':
    'Sind Sie sich absolut sicher, dass Sie diese {{entity}}-Zuweisung entfernen möchten?',
  'message.unassigned.confirm':
    'Wenn Sie die Entfernung der Zuweisung bestätigen, wird die Aktion ausgeführt. Es kann sein, dass die {{entity}}-Zuweisung aus einer Datenbank entfernt wird.',
  'message.unload.title': 'Nicht gespeicherte Änderungen',
  'message.unload.description':
    'Sie haben nicht gespeicherte Änderungen. Möchten Sie diese Seite wirklich verlassen?',
};
